var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-typography',{attrs:{"value":_vm.addedDateString,"margins":""}})}
var staticRenderFns = []

export { render, staticRenderFns }